import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { Comparison } from '@dgx-pr-spa/shared/util';
import { Specification } from '@dgx-pr-spa/shared/util';
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-spec-table',
  templateUrl: './spec-table.component.html',
  styleUrls: ['./spec-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpecTableComponent implements OnChanges {
  constructor(private readonly viewOfferService: ViewOffersService) {}
  /**
   * Receives array of comparisons to compare
   */
  @Input() comparisons = [] as Comparison[];

  /**
   * Array to store state of all specifications for each comparison
   */
  compareSpecs: Specification[][] = [];

  /**
   * Array to store each row spec differences
   */
  rowHasSpecDifferences: boolean[];

  /**
   * Filter by highlight only
   */
  @Input() filtered: boolean;

  /**
   * OnChanges to pickup changes to injected comparisons
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes?.comparisons) {
      this.compareSpecs = this.viewOfferService.getUniqueHeadings(
        this.comparisons
      );

      this.rowHasSpecDifferences =
        this.viewOfferService.createFilteredCompareSpecRow(this.compareSpecs);
    }
  }
}
